export default __webpack_public_path__ + "static/media/fries.deef1fd8.svg";